import React from 'react';
import { makeStyles, Container } from '@material-ui/core';
import clsx from 'clsx';
/**
 * Constants
 */
var LOGO = 'https://www.leaseplan.com/static/images/logo-footer-white.png';
/**
 * Styles
 */
var useStyles = makeStyles(function (theme) { return ({
    root: {
        backgroundColor: theme.palette.primary.dark,
        position: 'relative',
        color: theme.palette.primary.contrastText,
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(2),
    },
}); });
var useLeasePlanStyles = makeStyles(function (theme) {
    var _a, _b;
    return ({
        container: (_a = {
                paddingTop: theme.spacing(8),
                paddingBottom: theme.spacing(2)
            },
            _a[theme.breakpoints.up('xl')] = {
                paddingTop: theme.spacing(4),
                paddingRight: "calc(" + theme.spacing(3) + "px + 270px)",
            },
            _a),
        logo: (_b = {
                position: 'absolute',
                pointerEvents: 'none',
                zIndex: 1,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '290px',
                height: '153px',
                top: '-93px'
            },
            _b[theme.breakpoints.up('md')] = {
                top: '-109px',
                left: 'auto',
                right: theme.spacing(2),
                transform: 'none',
                width: '340px',
                height: '179px',
            },
            _b),
    });
});
/**
 * Footer component
 */
export var Footer = function (_a) {
    var className = _a.className, children = _a.children, containerClassName = _a.containerClassName;
    var classes = useStyles({});
    return (React.createElement("footer", { className: clsx(classes.root, className) },
        React.createElement(Container, { maxWidth: "lg", className: clsx(classes.container, containerClassName) }, children)));
};
/**
 * Default LeasePlan-styled footer implementation.
 */
export var LeasePlanFooter = function (_a) {
    var className = _a.className, children = _a.children;
    var classes = useLeasePlanStyles();
    return (React.createElement(Footer, { className: className, containerClassName: classes.container },
        React.createElement("img", { src: LOGO, className: classes.logo, "data-e2e-component": "footer-logo", alt: "LeasePlan Logo" }),
        children));
};
//# sourceMappingURL=Footer.js.map